module.exports = __webpack_public_path__ + "img/banner-slide-1.a36b9659.png";